/**
* @name: record-header
* @author: weiyong
* @date: 2024-06-16 21:06
* @description：record-header
* @update: 2024-06-16 21:06
*/
<template>
  <div class="record-header flex-div">
    <template v-for="(column,index) in cols">
      <div class="subFieldLabel" v-if="column.hideLabel===false">{{ column.propName }}:&nbsp;</div>
      <div class="time-line-cell">
        <grid-cell-ctl-show
          :cellContent="record[columnId||column.dataIndex||column.propId]"
          :index="index"
          :column="column"
          :record="record"/>
      </div>
      <template v-if="column&&(column.dataIndex === 'operation'||column.propType === 'operation')">
        <table-operation-show
                              :record="record"
                              :rowIndex="index"
                              :column="column"></table-operation-show>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';


export default defineComponent({
  components: {},
  name: "col-show-list",
});
</script>

<script lang="ts" setup>
import TableOperationShow from "@/main-page/commonVue/table-operation-show.vue";
import GridCellCtlShow from "@/main-page/gridCellCtlShow/index.vue";

const props=defineProps({
  cols:{},
  props:{},
  record:{}
})

</script>

<style type="text/css" lang="less">
.xmTimeLine.xmTimeLine-commonList{
  .record-header{
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    .time-line-cell{
      color:#666;
      padding-right: 8px;
    }
  }

  .subFieldLabel{
    font-size:13px;
    color:#777;
  }
}
</style>
